import { render, staticRenderFns } from "./SellerAccountDetails.vue?vue&type=template&id=d6c72a32&scoped=true"
import script from "./SellerAccountDetails.vue?vue&type=script&lang=js"
export * from "./SellerAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./SellerAccountDetails.vue?vue&type=style&index=0&id=d6c72a32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c72a32",
  null
  
)

export default component.exports